<tvcore-alert (close)="clearToast()" [action]="toast.action" [type]="toast.type">
	<span [innerHTML]="toast.message"></span>
</tvcore-alert>
